import React, { useEffect, useState } from "react";
import JournalDetailSection from "./JournalDetailSection";
import JournalSharedChatSection from "./JournalSharedChatSection";
import JournalSharedTribeSection from "./JournalSharedTribeSection";

const JournalDetailModal = ({
  isOpen,
  onClose,
  journal,
  originalSender = null,
  tribePostShared = false,
  tribePost = {},
  messageId = null,
  conversationId = null,
  originalMessage = null,
}) => {
  const [createdDate, setCreationDate] = useState("");

  if (!isOpen) return null;

  const journalTitle = journal?.emotion_name || "Journal";
  const creationDate = createdDate ? createdDate : "";

  return (
    <>
      <div
        className="modal-overlay"
        style={{
          zIndex: 1001,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            backgroundColor: "#132534",
            borderRadius: "12px",
            width: "90%",
            maxWidth: "1200px",
            height: "80vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "24px",
              borderBottom: "1px solid #333",
              position: "relative",
            }}
          >
            <div style={{ width: 40 }} />
            <div style={{ textAlign: "center", flex: 1 }}>
              <h3 style={{ color: "#e6ecf1", margin: 0, fontSize: "24px" }}>
                {journalTitle}
              </h3>
              {creationDate && (
                <p
                  style={{
                    color: "#8899a6",
                    margin: "4px 0 0",
                    fontSize: "14px",
                  }}
                >
                  {originalSender?.name} | {creationDate}
                </p>
              )}
            </div>
            <button
              onClick={onClose}
              style={{
                background: "none",
                border: "none",
                color: "#e6ecf1",
                fontSize: "28px",
                cursor: "pointer",
                lineHeight: 1,
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div
            className="content-body"
            style={{
              display: "flex",
              flex: 1,
              overflow: "hidden",
              padding: "0 24px 24px 24px",
              marginTop: "16px",
              gap: "18px",
            }}
          >
            <JournalDetailSection
              journal={journal}
              onCreationDate={setCreationDate}
            />
            {tribePostShared ? (
              <JournalSharedTribeSection tribePost={tribePost} />
            ) : (
              <JournalSharedChatSection
                journal={journal}
                originalSender={originalSender}
                messageId={messageId}
                conversationId={conversationId}
                originalMessage={originalMessage}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default JournalDetailModal;
